import styled, { css } from 'styled-components'
import { themeColor, themeFontFamily, themeFontWeight, UISizes } from 'LibNeo'
import { SwitchContainer } from 'LibNeo/components/Basic/Switch/SwitchComponent/styled'
import { CheckboxWrapper } from 'LibNeo/components/Basic/Checkbox/styled'

interface FormRowStyledProps {
	size?: UISizes.SMALL | UISizes.MEDIUM
	fixWidth?: boolean
	isString?: boolean
	vertical?: boolean
}

const formRowElementSize = {
	[UISizes.SMALL]: 180,
	[UISizes.MEDIUM]: 372,
}

export const FormRow = styled.div<{ vertical?: boolean }>`
	display: flex;
	margin-bottom: 16px;
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	font-size: 14px;
	line-height: 20px;
	color: ${themeColor('gray', 8)};
	font-family: ${themeFontFamily('SBSansText')};
	flex-direction: ${({ vertical }) => vertical && 'column'};
	@media (max-width: 1280px) {
		flex-direction: column;
	}
`

export const FormRowLabel = styled.div<Pick<FormRowStyledProps, 'isString'>>`
	flex-shrink: 0;
	width: 240px;
	padding-top: ${({ isString }) => (!isString ? '10px' : '4px')};
	display: inline-flex;
	color: ${themeColor('gray', 6)};
`

export const FormRowContent = styled.div<Pick<FormRowStyledProps, 'isString' | 'vertical'>>`
	width: 100%;
	display: inline-flex;
	margin-left: 40px;
	word-break: break-word;
	align-items: flex-start;
	min-height: 40px;
	${({ isString }) =>
		isString &&
		css`
			align-items: center;
			min-height: 28px;
		`};
	${({ vertical }) =>
		vertical &&
		css`
			margin: 10px 0 0;
		`};
	@media (max-width: 1280px) {
		margin: 10px 0 0;
	}
`

const CheckboxIndent = styled.div`
	& > ${CheckboxWrapper}, ${SwitchContainer} {
		margin-top: 10px;
	}
`

export const FormRowElement = styled(CheckboxIndent)<Omit<FormRowStyledProps, 'isString'>>`
	${({ size }) =>
		size &&
		css`
			width: ${formRowElementSize[size]}px;
			max-width: 100%;
		`}
	flex-grow: ${({ fixWidth }) => (fixWidth ? 'initial' : 1)};
`

export const FormRowAdditionalElement = styled(CheckboxIndent)<Pick<FormRowStyledProps, 'size'>>`
	${({ size }) =>
		size &&
		css`
			width: ${formRowElementSize[size]}px;
			max-width: 100%;
		`}
	margin-left: 12px;
`
